module.exports = __webpack_public_path__ + "img/delete.dc04520a.svg";